import { useEffect, useState } from "react";
import httpclient from "../httpclient";

export const GetImage = (props) => {
  const [filename, setFilename] = useState("");

  useEffect(() => {
    if (props.url) {
      getImageUrl();
    }
  }, [props.url]);

  const getImageUrl = async () => {
    await httpclient
      .GET(`${process.env.REACT_APP_BASE_API_URL}${props.url}`)
      .then((response) => {
        setFilename(response.data.data);
      }).catch((err) => {
        console.log(err)
      });
  };

  return (
    <img
      alt={props.alt}
      src={filename}
      className={props.className}
      style={props.style}
      onLoad={props.onLoad}
      onError={(event) =>
        (event.target.src = `${process.env.REACT_APP_PUBLIC_URL}images/placeholder.png`)
      }
      onClick={props.onClick}
      {...props}
    />
  );
};
